export const ENGLISH = 'en';
export const FRENCH = 'fr';
export const DUTCH = 'nl';
export const LANGUAGES = [ENGLISH, FRENCH, DUTCH];
export const DEFAULT_LANGUAGE = ENGLISH;

export const ENGLISH_LANG_FILE = './assets/en.trimonitor.json';
export const FRENCH_LANG_FILE = './assets/fr.trimonitor.json';
export const DUTCH_LANG_FILE = './assets/nl.trimonitor.json';
